function OrderOverview({ counts }) {
  const orderMetrics = [
    { id: "new", label: "New Orders", value: counts?.new || 0, helperText: "Awaiting review" },
    { id: "preparing", label: "In Preparation", value: counts?.preparing || 0, helperText: "Currently being prepared" },
    { id: "delivery", label: "Out for Delivery", value: counts?.out_for_delivery || 0, helperText: "Scheduled for today" },
    { id: "completed", label: "Completed", value: counts?.completed_this_month || 0, helperText: "Completed this month" },
  ];

  return (
    <section className="order-overview">
      {orderMetrics.map((item) => (
        <article className="order-overview-card" key={item.id}>
          <div>
            <p>{item.label}</p>
            <strong>{item.value}</strong>
          </div>
          <span>{item.helperText}</span>
        </article>
      ))}
    </section>
  );
}

export default OrderOverview;
